import { Controller } from "@hotwired/stimulus"

// Closes an inline edit form, reverting the Turbo Frame to the saved entry.
// Pressing Escape or clicking the close button navigates the frame back.
export default class extends Controller {
  static targets = ["cancel"]

  closeOnEscape(event) {
    if (event.key !== "Escape") return
    event.preventDefault()
    this.cancelTarget.click()
  }
}
